import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { SingleMarketPlacePage } from '../single-market-place/single-market-place';
import { MarketplacecategoryPage } from '../marketplacecategory/marketplacecategory';
import { MarketplacesearchPage } from '../marketplacesearch/marketplacesearch';
import { MarketplaceProvider } from '../../providers/marketplace/marketplace';

import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';


@IonicPage()
@Component({
  selector: 'page-market-place',
  templateUrl: 'market-place.html',
})
export class MarketPlacePage {
  category = [];
  marketPlace = [];
  oneMarketPlace: any;
  user_tenant = false;
  societyUUID: any;
  marketUUID: any;
  trendings: any;
  defaultItem: any;
  defaultName: any;
  defaultRating: any;
  defaultClicked: any;
  defaultPrice: any;
  defaultOff: any;
  defaultImage: any;
  allUsersList= [];
  userIdNameMap = [];
  userIdEmailMap = [];
  userIdPhoneMap = [];
  userIdTenantOrResidentMap = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    private marketplaceprovider: MarketplaceProvider,
    private storage: Storage) {


    this.storage.get("loginDetails").then(val => {
      if (val.tenant) {
        this.user_tenant = val.tenant;
      }
    });

    
    this.marketplaceprovider.getUsersList().then(val => {
      val.forEach(value => {
        this.allUsersList[value.id] = value;
        this.userIdNameMap[value.id] = value.name;
        this.userIdEmailMap[value.id] = value.email;
        this.userIdPhoneMap[value.id] = value.phone_no;
        this.userIdTenantOrResidentMap[value.id] = value.tenant == 0 ? 'Tenant' : value.tenant == 1 ? 'Resident' : 'Admin';
      });


    })

    marketplaceprovider.getMarketPlace().then(val => {
      // this.showData = true;
      this.marketPlace = val['data'];
      this.oneMarketPlace = this.marketPlace[0];
      this.societyUUID = this.oneMarketPlace.society_uuid;
      this.marketUUID = this.oneMarketPlace.uuid;



      this.marketplaceprovider.getAllCategories(this.marketUUID).then(val => {
        this.category = val['data'];
        console.log(val, "all categories");
      });
      this.marketplaceprovider.getMarketTrending(this.marketUUID).then(val => {
        this.trendings = val['data'];
        this.defaultItem = this.trendings[0];
        this.defaultName = this.defaultItem['name'];
        this.defaultRating = this.defaultItem['rating'];
        this.defaultPrice = this.defaultItem['price'];
        this.defaultOff = this.defaultItem['percent_off'];
        this.defaultClicked = this.defaultItem['clicked'];
        this.defaultImage = this.defaultItem['images'][0];
        console.log(this.defaultImage)
        console.log(this.defaultItem)
        console.log(this.trendings);
      })

    });

  }

  singlePage(item) {
    this.navCtrl.push(SingleMarketPlacePage, {
      societyuuid: this.societyUUID,
      marketuuid: this.marketUUID,
      itemid: item.uuid,
      itemSingle: item,
      userList : this.allUsersList

    });
  }

  categoryPage(item) {
    console.log(item);
    this.navCtrl.push(MarketplacecategoryPage, {
      name: item.name,
      uuid: item.uuid,
      marketuuid: this.marketUUID,
      societyuuid: this.societyUUID,
      userList : this.allUsersList,

    });
  }

  openSearch() {
    this.navCtrl.push(MarketplacesearchPage, {
      marketuuid: this.marketUUID,
      societyuuid: this.societyUUID,

    });
  }



  ionViewDidLoad() {
    console.log('ionViewDidLoad MarketPlacePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/market-place/market-place.ts